import * as React from "react";
const SvgChevronLeft = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M14.269 5.269A1.034 1.034 0 1 1 15.73 6.73L10.463 12l5.268 5.268a1.034 1.034 0 1 1-1.463 1.463l-6-6a1.034 1.034 0 0 1 0-1.463z" })));
export default SvgChevronLeft;
//# sourceMappingURL=ChevronLeft.js.map